import { Injectable } from '@angular/core';
import { BaseService } from '../../../core/service/base-service';
import { MoistureModal } from '../modal/moisture-modal';
import { HttpClient } from '@angular/common/http';
import { AuthUtilsService } from '../../../core/util/auth-utils.service';

@Injectable({
  providedIn: 'root',
})
export class MoistureModalService extends BaseService<MoistureModal> {
  pagination: { pageIndex: number; perPage: number };
  constructor(http: HttpClient, authService: AuthUtilsService) {
    super(http, authService);
  }

  getModuleName(): string {
    return 'chemical/moisture';
  }

  validate(): boolean {
    return false;
  }
}
